<template>
	<v-col class="ma-0 pa-0" cols="12" align="center">
		<v-row class="ma-0 pa-0" align="center">
      <v-col v-for="(item, index) in videoStreamList" :key="item.id"
				class="ma-0 pa-2" cols="4" align="center"
				:class="{'non_display': videoStreamList[index] == undefined || streamingUrlLoading }">
				<ThumbnailListItem
					:item="item" :index="index" :imgLoaders="imgLoaders"
					:streamingUrlLoading="streamingUrlLoading" @onLoad="onLoadFunc" />
      </v-col>
			<v-col class="ma-0 pa-15" cols="12" align="center"
				v-if="videoStreamList.length == 0 && streamingUrlLoading == false">
				{{t('noData')}}
			</v-col>
		</v-row>

		<template v-if="streamingUrlLoading">
			<ImageSkeleton :loaderCount="9" width='100%' height='208px' />
		</template>
	</v-col>
</template>

<script>
import mixin from '@/mixin';
import ThumbnailListItem from '@/components/ThumbnailListItem.vue';
import ImageSkeleton from '@/components/loader/ImageSkeleton.vue';
export default {
	props: {
		priority: { type: Number, default: 3 },
	},
	components: {
		ThumbnailListItem, ImageSkeleton
	},
	mixins: [mixin.common],
	data: () => ({
		streamList: [],
    videoStreamList:[],
		streamingUrlLoading: false,
		imgLoaders: [],
    deviceStatusList: ['5', '10', '12', '17', '19', '20'],
    deviceErrorStr: '',
		tempList: [],
	}),
	watch: {
		priority: function(item) {
			this.listSorting(item);
		}
	},
	filters: {
		statusFormat: function(str) {
			if(str != undefined) {
				return str.length > 20 ? str.substring(0,20) + '...' : str;
			} else {
				return '';
			}
		}
	},
	created() {
		for(var i = 0; i < 99; i++) {
			this.imgLoaders.push(true)
		}
	},
	mounted() {
		this.getCameraList();
	},
	methods: {
		getCameraList() {
			this.streamingUrlLoading = true;
			this.imgLoaders = [];
			for(var i = 0; i < 99; i++) {
				this.imgLoaders.push(true)
			}
			let params = {};
			this.networkController.getDashboardCameraList(params)
			.then(async (res) => {
				console.log('%cDashboard Camera List\n', "color:#008DD0;", res.data);
				this.streamList = res.data;
				if(res.data.length != 0) {
					this.videoStreamList = [];
					this.tempList = [];
					this.streamList.forEach((item, index) => {
						if(this.checkVideoStreamAvailable(item) == false) {
							let data = item;
							data.streamAble = false;
							if(item.isUas == false) {
								this.tempList.push(data);
							}
							if(index == this.streamList.length - 1) {
								setTimeout(() => {
									this.listSorting(this.priority);
								}, 250);
							}
						} else {
							let data = item;
							data.streamAble = true;
							this.tempList.push(data);
							if(index == this.streamList.length - 1) {
								setTimeout(() => {
									this.listSorting(this.priority);
								}, 250);
							}
						}
					});
				} else {
					this.streamingUrlLoading = false;
				}
			}).catch(error => {
				this.streamingUrlLoading = false;
			});
		},
		listSorting(priority) {
			if(priority == 0) { // 시청자 많은순
				this.videoStreamList = this.tempList.sort(function(a, b) {
					return (a.view > b.view) ? -1 : ((a.view < b.view) ? 1 : 0);
				});
			} else if(priority == 3) { // 카메라이름 오름차순
				this.videoStreamList = this.tempList.sort(function(a, b) {
					return (a.cameraName < b.cameraName) ? -1 : ((a.cameraName > b.cameraName) ? 1 : 0);
				});
			} else if(priority == 4) { // 카메라이름 내림차순
				this.videoStreamList = this.tempList.sort(function(a, b) {
					return (a.cameraName > b.cameraName) ? -1 : ((a.cameraName < b.cameraName) ? 1 : 0);
				});
			} else if(priority == 5) { // 등록 오름차순
				this.videoStreamList = this.tempList.sort(function(a, b) {
					return (new Date(a.createTime).getTime() < new Date(b.createTime).getTime()) 
						? -1 : ((new Date(a.createTime).getTime() > new Date(b.createTime).getTime()) ? 1 : 0);
				});
			} else if(priority == 6) { // 등록 내림차순
				this.videoStreamList = this.tempList.sort(function(a, b) {
					return (new Date(a.createTime).getTime() > new Date(b.createTime).getTime()) 
						? -1 : ((new Date(a.createTime).getTime() < new Date(b.createTime).getTime()) ? 1 : 0);
				});
			}
			this.streamingUrlLoading = false;
		},
		onLoadFunc(data) {
			this.imgLoaders.splice(data.index, 1, data.value);
		},
	}
}
</script>

<style lang="scss" scoped>
.non_display {
	display: none;
}
</style>